import { styled } from '@mui/material'
import {
  SenderName,
  MessageDescriptor,
  MessagePreviewSkeleton,
} from './components'
import { ReplySmallIcon } from '$common/icons/reply'
import { useMessageByIid } from '$logic/message/react-hook'
import { scrollToMessageByIid } from '$logic/opened-room'
import { RemovePersonIcon } from '$common/icons/removed-message'
import {
  MessagePreviewRoot,
  MessagePreviewVerticalSideBox,
  MessagePreviewThumbnail,
  MessagePreviewInfoContainer,
  MessagePreviewInfoRow,
  MessagePreviewMessageTypeIconMap,
  MessagePreviewDescriptorContainer,
} from '$common/messsage-preview'

const StyledReplyIcon = styled(ReplySmallIcon)`
  width: 20px;
  height: 18px;
  /* @noflip */
  margin: -2px 0 0 4px;
`

interface Props {
  messageIid: number
  roomId: string
  shorten?: boolean
}

export function Reply({ messageIid, roomId, shorten }: Props) {
  const { message, loading } = useMessageByIid(messageIid, roomId)

  if (!message)
    return (
      <MessagePreviewRoot>
        <MessagePreviewVerticalSideBox />
        <MessagePreviewSkeleton />
      </MessagePreviewRoot>
    )

  const isDeleted = message?.patches?.deleted
  const showReplyIcon = !shorten || message?.type === 'EVENT'
  const MessageTypeIcon =
    !isDeleted && message && MessagePreviewMessageTypeIconMap[message.type]

  const hasTypeIcon = !!MessageTypeIcon

  return (
    <MessagePreviewRoot
      onClick={e => {
        e.stopPropagation()
        if (!(isDeleted || loading)) scrollToMessageByIid(messageIid)
      }}
      style={isDeleted || loading ? {} : { cursor: 'pointer' }}
    >
      <MessagePreviewVerticalSideBox />

      {loading ? (
        <MessagePreviewSkeleton />
      ) : (
        <>
          {!isDeleted && <MessagePreviewThumbnail message={message} />}

          <MessagePreviewInfoContainer>
            <MessagePreviewInfoRow>
              {isDeleted ? (
                <RemovePersonIcon />
              ) : (
                showReplyIcon && <StyledReplyIcon />
              )}

              <SenderName message={message} />
            </MessagePreviewInfoRow>

            <MessagePreviewInfoRow>
              {hasTypeIcon && (
                <MessageTypeIcon
                  sx={{ width: '20px', height: '16px', color: 'gray' }}
                />
              )}
              <MessagePreviewDescriptorContainer hasMarginToIcon={hasTypeIcon}>
                <MessageDescriptor message={message} />
              </MessagePreviewDescriptorContainer>
            </MessagePreviewInfoRow>
          </MessagePreviewInfoContainer>
        </>
      )}
    </MessagePreviewRoot>
  )
}

Reply.defaultProps = {
  shorten: false,
}
